import { createAsyncThunk } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { requestService } from '../../services/requestService'
import { GET_CHILDREN_REQUESTS_DATA, GET_PARENT_REQUEST_DATA, GET_REQUEST_DATA } from '../config'
import {
  IChildrenRequestsActionParams,
  IParentRequestActionParams,
  IRequestActionParams,
} from '../models'
import { selectChildrenRequestsLoadingStatus } from '../selectors/selectChildrenRequestsData'
import { selectParentRequestLoadingStatus } from '../selectors/selectParentRequestData'
import { selectRequestLoadingStatus } from '../selectors/selectRequestData'

import { handleApiResponse } from './helpers/handleApiResponse'

class RequestApi {
  public getRequestData = createAsyncThunk(
    GET_REQUEST_DATA,
    async ({ requestId }: IRequestActionParams, _thunkAPI) => {
      const response = await requestService.fetchRequest(requestId)
      return handleApiResponse(response)
    },
    {
      condition({ requestId }, { getState }) {
        if (!requestId) {
          return false
        }

        const state = getState() as any
        const status = selectRequestLoadingStatus(state)
        if (status === RequestStatus.PENDING) {
          return false
        }

        return
      },
    }
  )

  public getChildrenRequests = createAsyncThunk(
    GET_CHILDREN_REQUESTS_DATA,
    async ({ requestId }: IChildrenRequestsActionParams, _thunkAPI) => {
      const response = await requestService.fetchChildrenRequests(requestId)
      return handleApiResponse(response)
    },
    {
      condition({ requestId }, { getState }) {
        if (!requestId) {
          return false
        }

        const state = getState() as any
        const status = selectChildrenRequestsLoadingStatus(state)
        if (status === RequestStatus.PENDING) {
          return false
        }

        return
      },
    }
  )

  public getParentRequest = createAsyncThunk(
    GET_PARENT_REQUEST_DATA,
    async ({ requestId }: IParentRequestActionParams, _thunkAPI) => {
      const response = await requestService.fetchRequest(requestId)
      return handleApiResponse(response)
    },
    {
      condition({ requestId }, { getState }) {
        if (!requestId) {
          return false
        }

        const state = getState() as any
        const status = selectParentRequestLoadingStatus(state)
        if (status === RequestStatus.PENDING) {
          return false
        }

        return
      },
    }
  )
}

export const requestApi = new RequestApi()
